<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic" >Mirror</h4>

          <el-form :model="From" 
            ref="From" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="small"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Mirror Enable:">
                <el-switch v-model="flag" ></el-switch>
            </el-form-item>
            <div v-if="flag">

            
             <el-form-item label="Target Port :" prop="port" >
                <!-- AIS LAN NUM 4 -->
                <el-select v-model="From.port" placeholder="Please select" style="width: 100%" v-if="$G_DEVICE_CFG.lanNum === 4">
                    <el-option label="lan1" value="0x1"></el-option>
                    <el-option label="lan2" value="0x2"></el-option>
                    <el-option label="lan3" value="0x4"></el-option>
                    <el-option label="lan4" value="0x8"></el-option>
                </el-select>
                <!-- GTD LAN NUM 2 -->
                <el-select v-model="From.port" placeholder="Please select" style="width: 100%" v-else>
                    <el-option label="lan1" value="0x4"></el-option>
                    <el-option label="lan2" value="0x8"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="Mirror :" prop="mirror">
                <el-select v-model="From.mirror" placeholder="Please select" style="width: 100%">
                     <el-option label="both" value="0"></el-option>
                     <el-option label="ingress" value="1"></el-option>
                     <el-option label="egress" value="2"></el-option>
                </el-select>
            </el-form-item>
            </div>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      flag: true,
      From: {
        port: "0x1",
        mirror: "0"
      },
      portLists: [],
      mirrorLists: []
    };
  },
  methods: {
    init() {
      let getData = {
        CmdType: "GET_MIRROR"
      };
      axios.post("/boafrm/fromMirror", getData).then(res => {
        let data = res.data;
        if (data.ret == "0") {
          if (data.mirrorSwitch) {
            this.flag = true;
            this.From.port = data.lanPort;
            this.From.mirror = data.mirrorWay;
          } else {
            this.flag = false;
          }
        } else {
          this.$message.error("Data acquisition error！");
        }
      });
    },
    save() {
      var postDta = {
        CmdType: "SET_MIRROR",
        lanPort: this.From.port,
        mirrorWay: this.From.mirror // 1 rx 2 tx
      };
      if (this.flag == false) {
        postDta = {
          CmdType: "SET_CLOSEMIRROR"
        };
      }
      axios.post("/boafrm/fromMirror", postDta).then(res => {
        var data = res.data;
        if (data && data != "") {
          if (data.ret == "0") {
            this.$message.success("Configuration Successful！");
          } else {
              this.$message.error("Configuration Failed！");
          }
        } else {
           this.$message.error("Data acquisition error！");
        }
      });
    }
  },
  created() {
    this.From.port = (this.$G_DEVICE_CFG.lanNum === 4) ? '0x1' : '0x4'
    this.init();
  }
};
</script>






